import React, { useState, useCallback, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';
import Snackbar from '@material-ui/core/Snackbar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CameraIcon from '@material-ui/icons/Camera';
import CloseIcon from '@material-ui/icons/Close';
import FlipCameraIosIcon from '@material-ui/icons/FlipCameraIos';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import PublishIcon from '@material-ui/icons/Publish';
import MuiAlert from '@material-ui/lab/Alert';
import { FileDrop } from 'react-file-drop';
import ReactCrop from 'react-image-crop';
import Webcam from 'react-webcam';
import 'react-image-crop/dist/ReactCrop.css';

import './image-crop.css';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  preview: {
    maxWidth: theme.spacing(50),
  },
  paper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    // width: '100%',
    // minWidth: theme.spacing(80),
    maxWidth: theme.spacing(140),
    // maxHeight: theme.spacing(110),
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
      width: 'auto',
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(0.75),
      paddingBottom: theme.spacing(0.75),
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.header.main,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75),
  },
  snackbar: {
    top: '250%',
    width: '100%',
  },
  actionButton: {
    margin: theme.spacing(3),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1.5),
    color: theme.palette.neutral.main,
  },
  closeIcon: {
    width: theme.spacing(3.3),
    height: theme.spacing(3.3),
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
  },
  appBar: {
    position: 'relative',
    backgroundColor: theme.palette.secondary.main,
    boxShadow: 'none',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: 'white',
  },
  dialogPaper: {
    height: '40% !important',
    minHeight: '80%',
    maxHeight: '80%',
  },
  container: {
    display: 'flex',
    padding: '5%',
    paddingBottom: 0,
  },
  cropper: {
    margin: 'auto',
    height: '90%',
    justifyContent: 'center',
  },
  croppedpreview: {
    margin: 'auto',
    padding: '5%',
  },
  canvas: {
    height: 'auto',
  },
}));

function generateDownload(canvas, crop) {
  return crop && canvas ? canvas.toDataURL('image/jpeg') : null;
}

const pixelRatio = window.devicePixelRatio;

const CameraCapture = ({ acceptPhoto, onCancel, visible }) => {
  const classes = useStyles();
  const webcamRef = React.useRef(null);
  const [previewPhoto, setPreviewPhoto] = useState(null);
  const [modalContentType, setModalContentType] = useState(null);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const hiddenFileInput = React.useRef(null);
  const [open, setOpen] = useState(false);
  const imgRef = useRef();
  const [crop, setCrop] = useState({
    unit: '%',
    width: 100 / pixelRatio,
    height: 100 / pixelRatio,
    aspect: 4 / 5,
  });

  const [completedCrop, setCompletedCrop] = useState(null);
  const previewCanvasRef = useRef(null);

  // const matches = useMediaQuery('(max-width:425px)');

  let CroppedImage;

  const onLoad = useCallback((img) => {
    setCrop({ unit: '%', width: img.width, height: img.height });
    imgRef.current = img;
  }, []);

  useEffect(
    () => {
      if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
        return;
      }

      const image = imgRef.current;
      const canvas = previewCanvasRef.current;
      const crop = completedCrop;

      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;

      const pixelRatio = window.devicePixelRatio;

      canvas.width = crop.width * pixelRatio;
      canvas.height = crop.height * pixelRatio;
      const ctx = canvas.getContext('2d');
      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = 'high';

      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );

      CroppedImage = canvas.toDataURL('image/jpeg');
    },
    [completedCrop],
    [previewCanvasRef]
  );

  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBarOpen(false);
  };

  /**
   * Helper function to base64 encode an image
   * @param {file} file File to be base64 encoded
   */
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  /**
   * Capture a still image from the webcam.
   */
  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setPreviewPhoto(imageSrc);
    setOpen(true);
    // setModalContentType('confirm');
  };

  /**
   * handle file upload
   * @param {object} event change event from the file field
   */
  const upload = async (photo) => {
    const result = await toBase64(photo).catch((e) => Error(e));
    if (result instanceof Error) {
      console.log('Error: ', result.message);
      return;
    }
    setPreviewPhoto(result);
    // setModalContentType(null);

    // setModalContentType('confirm');
    setOpen(true);
  };
  const uploadHandler = (event) => {
    const photo = event.target.files[0];
    if (typeof photo === 'undefined') {
      setOpen(false);
      setSnackBarOpen(false);
    } else if (photo && photo.size < 100000) {
      upload(photo);
    } else {
      setOpen(!open);
      setSnackBarOpen(!snackBarOpen);
    }
  };

  /**
   * Clear the preview rendering and set modal content type to null
   */
  const clearPreview = () => {
    setPreviewPhoto(null);
    setModalContentType(null);
    setOpen(false);
  };

  /**
   * Accept previewed image and call accept handler from parent component
   */
  const accept = () => {
    acceptPhoto(previewPhoto);
    clearPreview();
  };

  const handleClose = () => {
    // TODO: Implement Edit Feature in future
    // acceptPhoto(previewPhoto);
    // setModalContentType(null);
    setOpen(false);
    clearPreview();
    // setCropPreview(false);
  };

  const showCroppedImage = useCallback(async () => {
    try {
      // TODO: implement these edit features
      // onCropComplete();
      // const thisImg = await getCroppedImg(imgRef, completedCrop, 'cropped.jpeg');
      // console.log('donee', { croppedImage });

      // setCroppedImage(thisImg);
      CroppedImage = generateDownload(previewCanvasRef.current, completedCrop);
      setPreviewPhoto(CroppedImage);

      // setCropPreview(true);
    } catch (e) {
      console.error(e);
    }
  });

  const handleSave = () => {
    showCroppedImage();
    setOpen(false);
    setModalContentType('confirm');
  };

  const [cameraBackSide, setCameraBackSide] = useState('user');

  const videoConstraints = {
    facingMode: { exact: cameraBackSide },
  };

  /**
   * Generate the content of the camera capture modal.
   */
  const generateModalContent = () => {
    switch (modalContentType) {
      case 'camera':
        return (
          <>
            <Webcam
              audio={false}
              height={`${100}%`}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              width={`${100}%`}
              screenshotQuality={0.75}
              videoConstraints={videoConstraints}
            />
            <div>
              <Button
                className={classes.actionButton}
                variant="contained"
                color="secondary"
                endIcon={<CameraIcon />}
                onClick={() => {
                  capture();
                }}
              >
                Capture photo
              </Button>
              <Button
                className={classes.actionButton}
                variant="contained"
                endIcon={<FlipCameraIosIcon />}
                color="secondary"
                onClick={() =>
                  cameraBackSide === 'user'
                    ? setCameraBackSide('environment')
                    : setCameraBackSide('user')
                }
              >
                Flip Camera
              </Button>
              <Button className={classes.actionButton} onClick={() => clearPreview()}>
                Cancel
              </Button>
            </div>
          </>
        );
      case 'confirm':
        return (
          <>
            <img className={classes.preview} src={previewPhoto} alt="potential headshot" />
            <div>
              <Button
                className={classes.actionButton}
                variant="contained"
                color="secondary"
                onClick={() => accept()}
              >
                Accept
              </Button>
              <Button
                className={classes.actionButton}
                style={{ marginRight: '-24px' }}
                onClick={() => clearPreview()}
              >
                Cancel
              </Button>
            </div>
          </>
        );

      default:
        return (
          <>
            <div>
              <FileDrop onDrop={(files) => upload(files[0])}>Drag and Drop An Image Here</FileDrop>
            </div>
            <div>
              <Button
                className={classes.actionButton}
                variant="contained"
                onClick={() => hiddenFileInput.current.click()}
                endIcon={<PublishIcon />}
                color="secondary"
              >
                File Upload
              </Button>
              <Button
                className={classes.actionButton}
                variant="contained"
                onClick={() => setModalContentType('camera')}
                endIcon={<PhotoCameraIcon />}
                color="secondary"
              >
                Take Photo
              </Button>
            </div>
            <input
              type="file"
              ref={hiddenFileInput}
              onChange={uploadHandler}
              style={{ display: 'none' }}
              onClick={() => setOpen(false)}
            />
            <Snackbar
              open={snackBarOpen}
              onClose={handleSnackBarClose}
              className={classes.snackbar}
              autoHideDuration={3000}
            >
              <Alert onClose={handleSnackBarClose} severity="error">
                Maximum Image Size Exceeded (100KB)
              </Alert>
            </Snackbar>
          </>
        );
    }
  };
  let modalTitle = '';
  switch (modalContentType) {
    case 'camera':
      modalTitle = 'Take Photo';
      break;
    case 'confirm':
      modalTitle = 'Confirm Photo';
      break;
    default:
      modalTitle = 'Select Image';
  }

  return (
    <div>
      <Modal
        className={classes.modal}
        open={visible}
        onClose={() => {
          onCancel();
          clearPreview();
        }}
      >
        <div className={classes.paper}>
          <IconButton
            className={classes.closeButton}
            disableRipple
            onClick={() => {
              onCancel();
              clearPreview();
            }}
          >
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
          <h2>{modalTitle}</h2>
          {generateModalContent()}
        </div>
      </Modal>
      <Dialog open={open} onClose={handleClose} fullWidth classes={{ paper: classes.dialogPaper }}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              Crop Photo
            </Typography>
            <Button
              autoFocus
              variant="text"
              color="inherit"
              onClick={handleSave}
              size="large"
              // style={
              //   matches
              //     ? { position: 'fixed', top: '20vh', right: '30vw' }
              //     : { position: 'fixed', top: '20vh', right: '14vw' }
              // }
            >
              Save
            </Button>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon style={{ margin: 'auto' }} />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div className={classes.container}>
          <div className={classes.cropper}>
            <ReactCrop
              src={previewPhoto}
              crop={crop}
              onImageLoaded={onLoad}
              onChange={(percentCrop) => setCrop(percentCrop)}
              onComplete={(percentCrop) => setCompletedCrop(percentCrop)}
              maxWidth={400}
              minWidth={100}
              minHeight={100}
              className="reactCrop"
            />
          </div>
          <br />
        </div>
        <div className={classes.croppedpreview} style={{ textAlign: 'center' }}>
          Cropped Image Preview:
          <br />
          <canvas ref={previewCanvasRef} className={classes.canvas} />
        </div>
      </Dialog>
    </div>
  );
};

export default CameraCapture;
